import React from 'react'
import { Collapse } from 'antd'
import Text from 'antd/es/typography/Text'
import UnitTestsTable from './SubmissionUnitTestResultsTable'
import { useSelector } from 'react-redux'
import submissionSelectors from '../../../../../store/selectors/submission.selectors'

const SubmissionUnitTestResultsDetailed = () => {
    const openedSubmissionId = useSelector(submissionSelectors.openedSubmissionId)
    const unitTests = useSelector(state => state.assignment.unitTests)
    const unitTestResults = useSelector(state => state.assignment.unitTestResults)
    const layers = useSelector(state => state.assignment.layers)

    const passedTestsCount = unitTests.reduce(
        (acc, unitTest) =>
            acc +
            unitTestResults.find(
                unitTestResult => unitTestResult.file_id === openedSubmissionId && unitTestResult.ut_id === unitTest.id,
            )?.ut_passed,
        0,
    )
    const unitTestsGradePercent = unitTests.length ? Math.round((100 * passedTestsCount) / unitTests.length) : 0
    const unitTestsLayerWeight = layers.find(layer => layer.layer_name === 'UnitTests999')?.layer_weight
    const unitTestsGrade = (unitTestsGradePercent * unitTestsLayerWeight) / 100
    const unitTestsGradeRounded = Math.round(unitTestsGrade)

    return (
        !isNaN(passedTestsCount) &&
        !!unitTests.length && (
            <Collapse ghost bordered={false}>
                <Collapse.Panel
                    header={`Passed ${passedTestsCount}/${unitTests.length} unit tests`}
                    key='unit-tests'
                    extra={
                        isNaN(unitTestsGrade) ? null : (
                            <label>
                                <Text type='secondary' className='mr-8'>
                                    Unit tests grade
                                </Text>
                                {unitTestsGradeRounded}/{unitTestsLayerWeight}
                            </label>
                        )
                    }
                >
                    <UnitTestsTable />
                </Collapse.Panel>
            </Collapse>
        )
    )
}

export default SubmissionUnitTestResultsDetailed
